import { updateDoc } from 'firebase/firestore';
import {
  useChannelDoc,
  useCurrentUserGuid,
} from '../../../../firebase/useCollection';
import { useCallback } from 'react';
import { Message } from '../../type';
import { useUnreadCount } from '../store/useUnreadCount';
import { useChannel } from '../store/useChannelHooks';

export const useMarkRead = (channelGuid: string): (() => void) => {
  const userGuid = useCurrentUserGuid();
  const channel = useChannel(channelGuid);
  const channelDoc = useChannelDoc(channelGuid);
  const unreadCount = useUnreadCount({ type: 'channel', guid: channelGuid });
  return useCallback(async () => {
    if (unreadCount === 0) {
      return;
    }
    const lastMessage = channel?.lastMessage;
    if (!lastMessage) {
      return;
    }
    const checkpoint: Partial<Message> = {
      guid: lastMessage.guid,
      authorGuid: lastMessage.authorGuid,
      createdDate: lastMessage.createdDate,
      channelGuid: channel.guid,
      messageType: lastMessage.messageType || 'TEXT',
    };
    if (lastMessage.mediaPath) checkpoint.mediaPath = lastMessage.mediaPath;
    if (lastMessage.mediaType) checkpoint.mediaType = lastMessage.mediaType;

    await updateDoc(channelDoc, {
      [`readPositions.${userGuid}`]: checkpoint,
      [`unreadEstimations.${userGuid}`]: 0,
    });
  }, [userGuid, channel, channelDoc, unreadCount]);
};
